module.exports = __webpack_public_path__ + "static/img/客户墙00043.6767fdc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/客户墙00043.png
// module id = 1+YK
// module chunks = 1